"use client";

import { useEffect, useState, useSyncExternalStore } from "react";
import { detectPwaPlatform, type PwaPlatform } from "../pwa-install";

const NATIVE_READY_EVENT = "award-party:native-ready";

export interface UseDevicePlatformResult {
  platform: PwaPlatform;
  /** True only inside the iOS / Android app shell, not a Home Screen web app. */
  isNativeShell: boolean;
}

function subscribeToNativeShell(callback: () => void) {
  window.addEventListener(NATIVE_READY_EVENT, callback);
  return () => window.removeEventListener(NATIVE_READY_EVENT, callback);
}

function readNativeShell(): boolean {
  return document.documentElement.dataset.awardPartyNativeShell === "true";
}

function readNativeShellOnServer(): boolean {
  return false;
}

export function useDevicePlatform(): UseDevicePlatformResult {
  const [platform, setPlatform] = useState<PwaPlatform>("unknown");
  const isNativeShell = useSyncExternalStore(
    subscribeToNativeShell,
    readNativeShell,
    readNativeShellOnServer,
  );

  useEffect(() => {
    setPlatform(
      detectPwaPlatform({
        userAgent: window.navigator.userAgent,
        platform: window.navigator.platform,
        maxTouchPoints: window.navigator.maxTouchPoints,
      }),
    );
  }, []);

  return { platform, isNativeShell };
}
